export default "__VITE_ASSET__m_j5y9BX__"